import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=25ad7d8e&scoped=true&"
import script from "./project_list.vue?vue&type=script&lang=js&"
export * from "./project_list.vue?vue&type=script&lang=js&"
import style0 from "./project_list.vue?vue&type=style&index=0&id=25ad7d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad7d8e",
  null
  
)

export default component.exports